import React, { useCallback, useState } from 'react';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import axios from 'axios';
import { connect } from 'react-redux';
import { SecurityHelper } from 'sarsaparilla';

import ModifyGroupSizeModal from 'ui-permit/shared-components/registration/ModifyGroupSizeModal';

import * as permitActions from '../actions/permit';
import { readRuleValue, modifyIssuanceGroupSize } from '../utils/permitUtils';
import {
  DEFAULT_MAX_GROUP_SIZE,
  DEFAULT_MIN_GROUP_SIZE,
  MAX_GROUP_SIZE,
  MIN_GROUP_SIZE,
  ALL_DIVISIONS,
} from '../constants'
import PermitShape from '../utils/permitShape';
import issuanceShape from '../utils/issuanceShape';

const fetchMaxAvailableGroupSize = async (permit, issuance) => {
  const maxGroupSizeAvailableResponse = await axios.get(
    `/api/permits/${permit.id}/availability/${issuance.id}/maxgroupsize`,
    { headers: { Authorization: SecurityHelper.getAuthHeader() } }
  );
  return maxGroupSizeAvailableResponse.data.payload;
};

export const ModifyGroupSizeModalContainer = ({
  permit,
  issuance,
  updateIssuance,
  ...props
}) => {
  const [isModifyingGroupSize, setIsModifyingGroupSize] = useState(false);
  const permitRuleMaxGroupSize = readRuleValue(MAX_GROUP_SIZE, permit, issuance?.division_id || ALL_DIVISIONS) || DEFAULT_MAX_GROUP_SIZE;
  const permitRuleMinGroupSize = readRuleValue(MIN_GROUP_SIZE, permit, issuance?.division_id || ALL_DIVISIONS) || DEFAULT_MIN_GROUP_SIZE;
  const originalGroupSize = issuance?.group_info?.length || 0;

  const modifyGroupSize = useCallback(
    async (groupSize) => {
      const updatedIssuance = {
        ...modifyIssuanceGroupSize(issuance, groupSize),
        is_modify_quota: true,
      };

      setIsModifyingGroupSize(true);
      try {
        return await updateIssuance(updatedIssuance);
      } finally {
        setIsModifyingGroupSize(false);
      }
    },
    [issuance, updateIssuance, permit]
  );

  const handleFetchMaxAvailableGroupSize = useCallback(() => {
    return fetchMaxAvailableGroupSize(permit, issuance);
  }, [permit, issuance]);

  return (
    <ModifyGroupSizeModal
      {...props}
      isModifyingGroupSize={isModifyingGroupSize}
      originalGroupSize={originalGroupSize}
      permitRuleMaxGroupSize={permitRuleMaxGroupSize}
      permitRuleMinGroupSize={permitRuleMinGroupSize}
      modifyGroupSize={modifyGroupSize}
      fetchMaxAvailableGroupSize={handleFetchMaxAvailableGroupSize}
    />
  );
};

ModifyGroupSizeModalContainer.propTypes = {
  updateIssuance: PropTypes.func,
  modifyGroupSizeError: PropTypes.shape({}),
  permit: PermitShape,
  issuance: issuanceShape,
  isOpen: PropTypes.bool,
  onSuccess: PropTypes.func.isRequired,
  onRequestClose: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    modifyGroupSizeError: state.inyonwhitney.permit.update_issuance_error,
    issuance: state.inyonwhitney.permit.issuance,
    permit: state.inyonwhitney.permit.result,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateIssuance: bindActionCreators(permitActions.updateIssuance, dispatch),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModifyGroupSizeModalContainer);
